import { render, staticRenderFns } from "./PopupClinicPatternDetail.vue?vue&type=template&id=36356348&scoped=true&"
import script from "./PopupClinicPatternDetail.vue?vue&type=script&lang=ts&"
export * from "./PopupClinicPatternDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PopupClinicPatternDetail.vue?vue&type=style&index=0&id=36356348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36356348",
  null
  
)

export default component.exports